import React from 'react';
import AppStatus from '../AppStatus';

class StatusPage extends React.Component {
  render() {
    return (
      <div style={{ marginTop: -50 }}>
        <AppStatus {...this.props} isFullScreen={true} />
      </div>
    );
  }
}

export default StatusPage;



// WEBPACK FOOTER //
// ./src/components/pages/StatusPage.js